import $ from "jquery";
import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {

  // searchProduct: (searchText) => {
  //   console.log(
  //     {
  //       searchText,
  //     },
  //     "products=-----@"
  //   );
  //   //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

  //   toast.dismiss();
  //   return new Promise((resolve, reject) => {
  //     var url = apiURL + "/public/search";
  //     var settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: url,
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + store.get("authToken"),
  //         // fngprt: m.cookie.get("fngprt")
  //       },
  //       data: {
  //         searchText: searchText !== "" ? searchText : undefined,
  //       },
  //       success: function (response) {
  //         if (!response.error) {
  //           toast.success(
  //             response.memberMessage,
  //             { autoClose: 500 }
  //           );
  //         } else {
  //           toast.error(
  //             response.memberMessage,
  //             { autoClose: 500 }
  //           );
  //         }
  //         resolve(response);
  //       },
  //       error: function (error) {
  //         if (error.status == 401) {
  //           toast.error(
  //             "Your session has been expired. Please relogin.",
  //             { autoClose: 500 }
  //           );
  //           localStorage.clear();
  //           window.location.reload();
  //         } else if (error.statusText === "abort") {
  //         } else {
  //           toast.error(
  //             "Some error has occurred.",
  //             { autoClose: 500 }
  //           );
  //         }
  //       },
  //     };
  //     $.ajax(settings).done();
  //   });
  // },

  searchProduct: (searchText) => {
    toast.dismiss();

    return new Promise((resolve, reject) => {
      const url = apiURL + "/public/search";

      $.ajax({
        url,
        method: "GET",
        data: {
          searchText: searchText?.trim() || undefined,
        },
        success: function (response) {
          console.log("Response", response);
          resolve(response);
        },
        error: function (error) {
          // if (error.status === 401) {
          //   toast.error(
          //     "Your session has been expired. Please relogin.",
          //     { autoClose: 500 }
          //   );
          //   localStorage.clear();
          //   window.location.reload();
          // } else if (error.statusText === "abort") {
          //   return
          // } else {
          //   toast.error("Some error has occurred.", { autoClose: 500 });
          // }
          // reject(error);

          console.log(error)
          if (error?.statusText === "abort") {
            resolve({ error: true, aborted: true });
            return;
          }

          if (error?.status === 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
            return;
          }

          toast.error("Some error has occurred.", { autoClose: 500 });
          reject(error);
        },
      });
    });
  },


  // fetchProductsInfo: (
  //   productUrl,
  //   categoryUrl,
  //   brandUrl,
  //   filterCategoryList,
  //   filterBrandList,
  //   filterSubCategoryList,
  //   page,
  //   pageSize,
  //   searchText
  // ) => {
  //   console.log(
  //     {
  //       productUrl,
  //       categoryUrl,
  //       brandUrl,
  //       filterCategoryList,
  //       filterBrandList,
  //       filterSubCategoryList,
  //       page,
  //       pageSize,
  //       searchText,
  //     },
  //     "products=-----@"
  //   );
  //   //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

  //   toast.dismiss();
  //   return new Promise((resolve, reject) => {
  //     var url = apiURL + "/public/products";
  //     var settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: url,
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + store.get("authToken"),
  //         // fngprt: m.cookie.get("fngprt")
  //       },
  //       data: {
  //         sUrl: productUrl,
  //         categoryUrl,
  //         brandUrl,
  //         filterCategoryList,
  //         filterBrandList,
  //         filterSubCategoryList,
  //         limit: pageSize,
  //         page: page,
  //         searchText: searchText !== "" ? searchText : undefined,
  //       },
  //       success: function (response) {
  //         if (!response.error) {
  //           toast.success(
  //             response.memberMessage,
  //             { autoClose: 500 }
  //           );
  //         } else {
  //           toast.error(
  //             response.memberMessage,
  //             { autoClose: 500 }
  //           );
  //         }
  //         resolve(response);
  //       },
  //       error: function (error) {
  //         if (error.status == 401) {
  //           toast.error(
  //             "Your session has been expired. Please relogin.",
  //             { autoClose: 500 }
  //           );
  //           localStorage.clear();
  //           window.location.reload();
  //         } else if (error.statusText === "abort") {
  //         } else {
  //           toast.error(
  //             "Some error has occurred.",

  //             { autoClose: 500 }
  //           );
  //         }
  //       },
  //     };
  //     $.ajax(settings).done();
  //   });
  // },

  fetchProductsInfo: (
    productUrl,
    categoryUrl,
    brandUrl,
    filterCategoryList,
    filterBrandList,
    filterSubCategoryList,
    page,
    pageSize,
    searchText
  ) => {
    toast.dismiss();

    return new Promise((resolve, reject) => {

      const url = `${apiURL}/public/products`;

      const data = {
        sUrl: productUrl,
        categoryUrl,
        brandUrl,
        filterCategoryList,
        filterBrandList,
        filterSubCategoryList,
        limit: pageSize,
        page,
        ...(searchText?.trim() && { searchText: searchText.trim() }),
      };

      console.log(data, "products=-----@");

      $.ajax({
        url,
        method: "GET",
        crossDomain: true,
        async: true,
        data,
        success: function (response) {
          // if (!response.error) {
          //   toast.success(
          //     response.memberMessage,
          //     { autoClose: 500 }
          //   )
          // } else {
          //   toast.error(
          //     response.memberMessage,
          //     { autoClose: 500 }
          //   )
          // }
          console.log("Response", response);
          resolve(response);
        },
        error: function (error) {
          if (error.status === 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error("Some error has occurred.", { autoClose: 500 });
          }
          reject(error);
        },
      });
    })
  },



  deactivateProductId: (productId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/products";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { productId },

        success: function (response) {
          if (!response.error) {
            toast.success(
              response.memberMessage,
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },

  fetchProductList: () => {
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/product/list";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  // sendEnqury: (info) => {
  //   toast.dismiss();
  //   return new Promise((resolve, reject) => {
  //     var url = apiURL + "/client";
  //     var settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: url,
  //       method: "POST",
  //       headers: {
  //         Authorization: "Bearer " + store.get("authToken"),
  //         // fngprt: m.cookie.get("fngprt")
  //       },
  //       data: info,
  //       success: function (response) {
  //         resolve(response);
  //       },
  //       error: function (error) {
  //         if (error.status == 401) {
  //           toast.error(
  //             "Your session has been expired. Please relogin.",
  //             { autoClose: 500 }
  //           );
  //           localStorage.clear();
  //           window.location.reload();
  //         } else if (error.statusText === "abort") {
  //         } else {
  //           toast.error(
  //             "Some error has occurred.",
  //             { autoClose: 500 }
  //           );
  //         }
  //       },
  //     };
  //     $.ajax(settings).done();
  //   });
  // },



  // contactUs: (info) => {
  //   toast.dismiss();
  //   return new Promise((resolve, reject) => {
  //     var url = apiURL + "/contact";
  //     var settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: url,
  //       method: "POST",
  //       headers: {
  //         Authorization: "Bearer " + store.get("authToken"),
  //         // fngprt: m.cookie.get("fngprt")
  //       },
  //       data: info,
  //       success: function (response) {
  //         resolve(response);
  //       },
  //       error: function (error) {
  //         if (error.status == 401) {
  //           toast.error(
  //             "Your session has been expired. Please relogin.",
  //             { autoClose: 500 }
  //           );
  //           localStorage.clear();
  //           window.location.reload();
  //         } else if (error.statusText === "abort") {
  //         } else {
  //           toast.error(
  //             "Some error has occurred.",
  //             { autoClose: 500 }
  //           );
  //         }
  //       },
  //     };
  //     $.ajax(settings).done();
  //   });
  // },

  sendEnqury: (info) => {
    toast.dismiss();

    return new Promise((resolve, reject) => {
      const url = apiURL + "/client";

      $.ajax({
        url,
        method: "POST",
        data: info,
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status === 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error("Some error has occurred.", { autoClose: 500 });
          }
          reject(error);
        },
      });
    });
  },

  contactUs: (info) => {
    toast.dismiss();

    return new Promise((resolve, reject) => {
      const url = apiURL + "/contact";

      $.ajax({
        url,
        method: "POST",
        data: info,
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status === 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error("Some error has occurred.", { autoClose: 500 });
          }
          reject(error);
        },
      });
    });
  },
};

$.ajaxQ = (function () {
  //console.log("--------------------------");
  var id = 0,
    Q = {};
  $(document).ajaxSend(function (e, jqx) {
    jqx._id = ++id;
    Q[jqx._id] = jqx;
  });
  $(document).ajaxComplete(function (e, jqx) {
    delete Q[jqx._id];
  });
  return {
    abortAll: function () {
      var r = [];
      $.each(Q, function (i, jqx) {
        r.push(jqx._id);
        jqx.abort();
      });
      return r;
    },
  };
})();
export default Actions;
